export const formatFileSize = (bytes: number, language: "en" | "ar" = "en"): string => {
  if (bytes === 0) return "0 B";

  const k = 1024;
  const sizes = [
    {
      en: "B",
      ar: "ب",
    },
    {
      en: "KB",
      ar: "كب",
    },
    {
      en: "MB",
      ar: "مب",
    },
    {
      en: "GB",
      ar: "جب",
    },
    {
      en: "TB",
      ar: "تب",
    },
  ];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i][language]}`;
};
